import {CanDeactivate} from '@angular/router';
import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {CONTINUE_WITHOUT_SAVING} from '../../modules/sales-terminal/sales-terminal.constants';
import {PendingChangesComponent} from './pending-changes-component';
import {PendingChangesDialogComponent} from '../../components/pending-changes-dialog/pending-changes-dialog.component';
import {lastValueFrom, Observable} from 'rxjs';
import {MatDialog} from '@angular/material/dialog';
import {AuthService} from '../../services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class PendingChangesGuard implements CanDeactivate<PendingChangesComponent> {

  constructor(private translateService: TranslateService,
              private dialog: MatDialog,
              private authService: AuthService) {}

  public async canDeactivate(component: PendingChangesComponent): Promise<boolean> {
    if (typeof component.canDeactivate !== 'function') {
      this.checkAuthPendingChanges();
      return true;
    }
    if (component.canDeactivate()) {
      this.checkAuthPendingChanges();
      return true;
    }
    const action = await lastValueFrom(this.getAction(component));
    if (action === CONTINUE_WITHOUT_SAVING) {
      if (typeof component.continueWithoutSaving === 'function') {
        component.continueWithoutSaving();
      }
      this.checkAuthPendingChanges();
      return true;
    } else if (action) {
      if (this.authService.pendingChangesActive) {
        this.authService.pendingChangesActive = false;
        component.saveAndContinue(!!this.authService.pendingChangeAction);
      } else {
        component.saveAndContinue();
      }
      return true;
    }
    this.authService.pendingChangesActive = true;
    return false;
  }

  private checkAuthPendingChanges(): void {
    if (this.authService.pendingChangesActive) {
      this.authService.pendingChangesActive = false;
      if (this.authService.pendingChangeAction) {
        this.authService.pendingChangeAction();
      }
    }
  }

  private getAction(component: PendingChangesComponent): Observable<any> {
    const data: any = { pendingChangesDescription: component.pendingChangesDescription };
    if (component.isValid !== undefined) {
      data.canNotSave = !component.isValid;
    }
    if (component.buttonOk !== undefined) {
      data.buttonOk = component.buttonOk;
    }
    const dialog: PendingChangesDialogComponent = new PendingChangesDialogComponent(this.dialog, this.translateService, data);
    return dialog.dialogRef.afterClosed();
  }
}
